// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  // Reassign Popover messages
  User: 'User_LABEL.ATTESTATIONS',
  Account: 'Account_LABEL.ATTESTATIONS',
  Role: 'Role_LABEL.ATTESTATIONS',
  Entitlement: 'Ent_LABEL.ATTESTATIONS',
  'Child Entitlement': 'Ent2_LABEL.ATTESTATIONS',
  'By reassigning this {lineItem}, their associated items will be included. Any approvals or rejections will be cleared upon reassignment.':
    'CERTS_REASSIGN_TITLE',
  Cancel: 'CERTS_CANCEL',
  'Got it': 'CERTS_REJECT_SECONDARY_BTN',
  Close: 'CloseLabel',
  Comments: 'User_CERTCOMMENTS.ATTESTATIONS',
};
